<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Trade :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/settings#trades`">
                            Settings - Trades
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="trade_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> New</template>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-9">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.trade_name }" class="row">
                                <label class="col-xl-2 col-lg-3 col-sm-4 col-form-label text-sm-right">Trade Name:</label>
                                <div class="col-xl-10 col-lg-9 col-sm-8">
                                    <input type="text" name="trade_name" v-model="trade.trade_name" class="form-control" placeholder="Enter Trade Name" />
                                    <span v-if="errors.trade_name" class="text-danger">
                                        <span v-for="error in errors.trade_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveTrade(this)" :disabled="saving">
                Save Trade
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                trade_id: this.$route.params.id,
                trade: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getTrade: function() {
                //Get the data
                this.$http
                    .get('subcontractors/trade-edit' + (this.trade_id ? '/' + this.trade_id : ''))
                    .then(response => {
                        //Set all the data
                        this.trade = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveTrade: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('subcontractors/trade-edit' + (this.trade_id ? '/' + this.trade_id : ''), this.trade)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Trade Saved');

                    //Return to main list?
                    this.$router.push('/subcontractors/settings#trades');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getTrade();
        }
    }
</script>
